export default "__VITE_ASSET__BidEEoc$__"